import React from 'react';

class Footer extends React.Component {
 
    render(){
        return (
            <div>
                <footer class="main-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-3">
                                <p>
                                    Islevhusvej 7, 2700 Brønshøj,
                                    <br />
                                    CVR: 38971069
                                </p>
                                <p class="">
                                    TLF: 71873167
                                    <br />
                                    alaskacykler@mail.com
                                </p>
                            </div>
                            <div class="col-sm-1"></div>
                            <div class="col-sm-4">
                                <p>
                                    Mandag - Fredag: kl. 10:00 - 18:00
                                    <br />
                                    Lørdag: kl. 10:00 - 16:00
                                    <br />
                                    Søndag og helidag: køb af nye cykler kan aftales
                                </p>
                            </div>
                            <div class="col-sm-4">
                                <p>
                                    <ul class="icon">
                                        <li>
                                            <a href="https://www.facebook.com/friesercykler/" target="_block">
                                                <img src="../images/social/facebook.svg" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" target="_block"><img src="../images/social/twitter.svg" /></a>
                                        </li>
                                        <li>
                                            <a href="#" target="_block"><img src="../images/social/instagram.svg" /></a>
                                        </li>
                                    </ul>
                                </p>
                            </div>
                        </div>
                    </div>
                </footer>
                <p style={{ textAlign: 'center' }}>Vi tager forbehold for tastefejl som kan danne misforståelsen hos vores kunder. Hvis i har et spørgsmål er i velkommen for at kontakte os.</p>
            </div>
        )
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/Common/Footer.js